<template>
  <div class="page-wrapper board-screen">
    <div class="content container-fluid">
      <div class="acc-content">

        <div class="row" style=" padding-bottom: 40px">
          <div class="col-sm-12">
            <div class="multistep-form">

              <!-- Freelancer Multistep -->
              <div class="multistep-progress" id="freelance_step">
                <div class="container">
                  <div class="first-progress">
                    <div class="row align-items-center">
                      <div class="col-md-3">
                        <div class="board-logo">
                          <router-link to="/"><img src="@/assets/talento_agv/img/LOGO NEGRO.png" style="width: 70px; margin-top: -5px;" alt="Img"
                              class="img-fluid"></router-link>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <ul id="progressbar" class="progressbar" v-show="currentStep === 1">
                          <li class="progress-active">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-01.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 1/3</span>
                              <h5>Datos de Acceso</h5>
                            </div>
                          </li>
                          <li class="">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-02.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 2/3</span>
                              <h5>Datos Personales</h5>
                            </div>
                          </li>
                          <li class="">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-03.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 3/3</span>
                              <h5>Información Adicional</h5>
                            </div>
                          </li>
                        </ul>
                        <ul id="progressbar" class="progressbar" v-show="currentStep === 2">
                          <li class="progress-activated">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-01.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 1/3</span>
                              <h5>Datos de Acceso</h5>
                            </div>
                          </li>
                          <li class="progress-active">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-02.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 2/3</span>
                              <h5>Datos Personales</h5>
                            </div>
                          </li>
                          <li class="">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-03.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 3/3</span>
                              <h5>Información Adicional</h5>
                            </div>
                          </li>
                        </ul>
                        <ul id="progressbar" class="progressbar" v-show="currentStep === 3">
                          <li class="progress-activated">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-01.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 1/3</span>
                              <h5>Datos de Acceso</h5>
                            </div>
                          </li>
                          <li class="progress-activated">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-02.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 2/3</span>
                              <h5>Datos Personales</h5>
                            </div>
                          </li>
                          <li class="progress-active">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-03.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 3/3</span>
                              <h5>Información Adicional</h5>
                            </div>
                          </li>
                        </ul>
                        <ul id="progressbar" class="progressbar" v-show="currentStep === 4">
                          <li class="progress-activated">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-01.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 1/3</span>
                              <h5>Datos de Acceso</h5>
                            </div>
                          </li>
                          <li class="progress-activated">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-02.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 2/3</span>
                              <h5>Datos Personales</h5>
                            </div>
                          </li>
                          <li class="progress-activated">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-03.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 3/3</span>
                              <h5>Información Adicional</h5>
                            </div>
                          </li>
                        </ul>
                        <ul id="progressbar" class="progressbar" v-show="currentStep === 5">
                          <li class="progress-activated">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-01.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 1/3</span>
                              <h5>Datos de Acceso</h5>
                            </div>
                          </li>
                          <li class="progress-activated">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-02.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 2/3</span>
                              <h5>Datos Personales</h5>
                            </div>
                          </li>
                          <li class="progress-activated">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-03.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Paso 3/3</span>
                              <h5>Información Adicional</h5>
                            </div>
                          </li>
                          <!-- <li class="progress-activated">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-04.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Step 4/5</span>
                              <h5>Other Information</h5>
                            </div>
                          </li>
                          <li class="progress-active">
                            <div class="multi-step"><img src="@/assets/img/icon/wizard-icon-05.svg" alt="Img"></div>
                            <div class="steps-count">
                              <span>Step 5/5</span>
                              <h5>Email Verification</h5>
                            </div>
                          </li> -->
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Freelancer Multistep -->

              <!-- Accounting Onboard -->
              <div class="text-center field-card on-board select-account" v-if="currentStep === 1">
                <form :validation-schema="schema">
                  <div class="container">
                    <div class="row align-items-center">
                      <div class="col-md-12">
                        <h4 class="mb-5">Datos de Acceso al Sistema</h4>
                      </div>
                      <div class="col-md-4"></div>
                      <!-- <div class="col-md-4 col-lg-4">
                        <div class="input-block">
                          <label class="focus-label">Nombre de Usuario</label>
                          <input type="text" name="education['university_name'][]" class="form-control" v-model="username"/>
                        </div>
                      </div> -->
                    </div>
                    <div class="row align-items-center">
                      <div class="col-md-4"></div>
                      <div class="col-md-4 col-lg-4">
                        <div class="input-block">
                          <label class="focus-label">Correo Electrónico</label>
                          <input type="email" name="education['university_name'][]" class="form-control" v-model="email"/>
                        </div>
                      </div>
                    </div>
                    <div class="row align-items-center">
                      <div class="col-md-4"></div>
                      <div class="col-md-4 col-lg-4">
                        <div class="input-block">
                          <label class="focus-label">Contraseña <span class="label-star"> *</span></label>
                          <div class="position-relative">
                            <Field
                              name="password"
                              :type="showPassword ? 'text' : 'password'"
                              class="form-control pass-input mt-2"
                              v-model="password"
                              />
                              <!-- :class="{ 'is-invalid': errors.password }" -->
                            <span @click="toggleShow" class="toggle-password2">
                              <i
                                :class="{
                                  'fas fa-eye': showPassword,
                                  'fas fa-eye-slash': !showPassword,
                                }"
                              ></i>
                            </span>
                            <!-- <div class="invalid-feedback">{{ errors.password }}</div> -->
                            <!-- <div class="emailshow text-danger" id="password"></div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row align-items-center">
                      <div class="col-md-4"></div>
                      <div class="col-md-4 col-lg-4">
                        <div class="input-block">
                          <label class="focus-label">Confirmar Contraseña <span class="label-star"> *</span></label>
                          <div class="position-relative">
                            <Field
                              name="password"
                              :type="showPassword ? 'text' : 'password'"
                              class="form-control pass-input mt-2"
                              />
                              <!-- :class="{ 'is-invalid': errors.password }" -->
                            <span @click="toggleShow" class="toggle-password2">
                              <i
                                :class="{
                                  'fas fa-eye': showPassword,
                                  'fas fa-eye-slash': !showPassword,
                                }"
                              ></i>
                            </span>
                            <!-- <div class="invalid-feedback">{{ errors.password }}</div> -->
                            <!-- <div class="emailshow text-danger" id="password"></div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <!-- <input class="btn btn-prev prev_btn btn-back mt-5" name="next" type="button" value="Atrás" disabled> -->
                <input class="btn next_btn btn-primary btn-get btn-next mt-5" @click="nextStep('acceso_sistema')"
                  :disabled="currentStep === totalSteps" name="next" type="submit" value="Siguiente &nbsp;&nbsp;&nbsp;" style="font-weight: bold;">
                  
                <div class="align-items-center mt-4" style="font-weight: bold;">
                  Ya tienes una cuenta?<router-link to="/login" class="ms-1 text-agv-dos" style="text-decoration: underline;">Iniciar sesión</router-link>
                </div>
              </div>

              <!-- /Accounting Onboard -->

              <!-- Personal Info -->
              <div class="on-board field-card select-account select-btn" v-if="currentStep === 2">
                <div class="text-center onboard-head">
                  <h2>Información Personal</h2>
                  <p>Cuéntanos un poco más sobre ti.</p>
                  <!-- <p>Tell a bit about yourself. This information will appear on your public profile, so that potential
                    buyers can get to know you better.</p> -->
                </div>
                <!-- <info_personal></info_personal> -->
                <div class="field-item personal-info space-info">
                  <form>
                    <div class="row">
                      <div class="col-md-12 col-lg-12">
                        <div class="pro-form-img">
                          <div class="profile-pic">
                            <div class="img-preview">
                              <img v-if="imgPreviewApplicant" :src="imgPreviewApplicant" style="width:100%; height:100%;"/>
                            </div>
                            {{imgPreviewApplicant ? '' : 'Foto de Perfil'}}
                          </div>
                          <div class="upload-files">
                            <label class="file-upload image-upbtn">
                              <i class="feather-upload me-2"></i>Cargar Foto
                              <input 
                              type="file"
                              class="form-control" 
                              name="txt-imagen" 
                              accept="image/png, image/gif, image/jpeg"
                              @change="handlePhotoChangeApplicant"
                              />
                            </label>
                            <span>Se recomienda que la foto debe tener un tamaño de 450x450 y un tamaño máximo de 5mb.</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 col-lg-4">
                        <div class="input-block">
                          <label class="form-label">Nombres *</label>
                          <input type="text" class="form-control" v-model="name" @input="e => name = e.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-4 col-lg-4">
                        <div class="input-block">
                          <label class="form-label">Apellido Paterno *</label>
                          <input type="text" class="form-control" v-model="firstSurname" @input="e1 => firstSurname = e1.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-4 col-lg-4">
                        <div class="input-block">
                          <label class="form-label">Apellido Materno *</label>
                          <input type="text" class="form-control" v-model="secondSurname" @input="e2 => secondSurname = e2.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4">
                        <div class="input-block">
                          <label class="form-label">Tipo de Documento *</label>
                          <vue-select :options="typeDocs" id="type_doc" placeholder="Seleccionar" v-model="selectedTypeDoc"/>
                        </div>
                      </div>
                      <div class="col-md-4 col-lg-4">
                        <div class="input-block">
                          <label class="form-label">N° Documento *</label>
                          <input type="tel" class="form-control" v-model="n_doc" :maxlength="selectedTypeDoc == 'DNI' ? 8 : 12"/>
                        </div>
                      </div>
                      <div class="col-md-4 col-lg-4">
                        <div class="input-block">
                          <label class="form-label">Celular *</label>
                          <input type="tel" class="form-control" v-model="phone" maxlength="15"/>
                        </div>
                      </div>

                      <div class="col-md-3 col-lg-3">
                        <div class="input-block">
                          <label class="form-label">Fecha de Nacimiento</label>
                          <div class="cal-icon">
                            <datepicker
                              v-model="birthdate"
                              placeholder="Elegir Fecha"
                              class="form-control datetimepicker"
                              :editable="true"
                              :clearable="false"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 col-lg-3">
                        <div class="input-block">
                          <label class="form-label">Género *</label>
                          <vue-select :options="genders" id="gender" placeholder="Seleccionar" v-model="selectedGender"/>
                        </div>
                      </div>
                      <div class="col-md-3 col-lg-3">
                        <div class="input-block">
                          <label class="form-label">Estado Civil</label>
                          <vue-select :options="maritalStatus" id="marital_status" placeholder="Seleccionar" v-model="selectedMaritalStatus"/>
                        </div>
                      </div>
                      <div class="col-md-3 col-lg-3">
                        <div class="input-block">
                          <label class="form-label">Nacionalidad</label>
                          <input type="text" class="form-control" v-model="nationality" @input="e2 => nationality = e2.target.value.toUpperCase()"/>
                        </div>
                      </div>

                      <div class="col-md-3 col-lg-3">
                        <div class="input-block">
                          <label class="form-label">Pais</label>
                          <input type="text" class="form-control" v-model="country" @input="e => country = e.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-3 col-lg-3">
                        <div class="input-block">
                          <label class="form-label">Departamento</label>
                          <input type="text" class="form-control" v-model="departament" @input="e => departament = e.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-3 col-lg-3">
                        <div class="input-block">
                          <label class="form-label">Provincia</label>
                          <input type="text" class="form-control" v-model="province" @input="e => province = e.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-3 col-lg-3">
                        <div class="input-block">
                          <label class="form-label">Distrito</label>
                          <input type="text" class="form-control" v-model="district" @input="e => district = e.target.value.toUpperCase()"/>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="input-block min-characters">
                          <label class="form-label">Perfil Profesional *</label>
                          <textarea class="form-control" rows="5" v-model="personalDescription"></textarea>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="input-block min-characters">
                          <label class="custom_check">
                            <input type="checkbox" name="select_time" v-model="availabTravel" /><span
                              class="checkmark border-agv"
                            ></span>
                            Disponibilidad para viajar
                          </label>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="input-block min-characters">
                          <label class="custom_check">
                            <input type="checkbox" name="select_time" v-model="availabChangeResid" /><span
                              class="checkmark border-agv"
                            ></span>
                            Disponilidad para cambiar de residencia
                          </label>
                        </div>
                      </div>
                      <!-- <div class="col-md-3">
                        <div class="input-block min-characters">
                          <label class="custom_check">
                            <input type="checkbox" name="select_time" v-model="driversLicense" /><span
                              class="checkmark border-agv"
                            ></span>
                            Licencia de conducir
                          </label>
                        </div>
                      </div> -->
                      <div class="col-md-4">
                        <div class="input-block min-characters">
                          <label class="custom_check">
                            <input type="checkbox" name="select_time" v-model="disability"/><span
                              class="checkmark border-agv"
                            ></span>
                            Carnet CONADIS
                          </label>
                        </div>
                      </div>

                      <div class="col-md-4 col-lg-4">
                        <div class="input-block">
                          <label class="form-label">Licencia de conducir</label>
                          <vue-select :options="typesDriversLicense" id="driver_license" placeholder="Seleccionar" v-model="selectedDriversLicense"/>
                        </div>
                      </div>
                      <!-- <div class="col-md-4 col-lg-4">
                        <div class="input-block">
                          <label class="form-label">Expectativa salarial</label>
                          <input type="text" class="form-control" v-model="salary_expect"/>
                        </div>
                      </div> -->
                    </div>
                  </form>
                </div>
                
                <div class="text-center">
                  <input class="btn btn-prev prev_btn btn-back" @click="previousStep" :disabled="currentStep === 1"
                    name="next" type="button" value="Atrás">
                  <input class="btn next_btn btn-primary btn-get btn-next" @click="nextStep('datos_pers')"
                    :disabled="currentStep === totalSteps" name="next" type="submit" value="Siguiente &nbsp;&nbsp;" style="font-weight: bold;">
                </div>
                <div class="row">
                  <div class="col-md-10 offset-2">
                    <span>* Campos obligatorios</span>
                  </div>
                </div>
              </div>
              <!-- /Personal Info -->

              <!-- Skills & Experience -->
              <div class="on-board field-card select-account select-btn" v-if="currentStep === 3">
                <div class="text-center onboard-head">
                  <h2>Educación & Experiencia</h2>
                  <!-- <p>This is your time to shine. Let potential buyers know what you do best and how you gained your
                    skills, certifications and experience</p> -->
                </div>
                <!-- <info_adicional></info_adicional> -->
                <div class="field-item personal-info space-info">
                  <form>

                    <!-- Educacion -->
                    <div class="row">
                      <div class="col-md-12">
                        <h4>Educacion</h4>
                      </div>
                      <div class="col-md-6 col-lg-2">
                        <div class="input-block">
                          <label class="focus-label">Grado</label>
                          <vue-select :options="academicDegree" v-model="newEducation.degree" placeholder="Selecionar" />
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-5">
                        <div class="input-block">
                          <label class="focus-label">{{ newEducation.degree == 'Secundaria' ? 'Institución Educativa' : 'Centro de estudio' }}</label>
                          <input type="text" v-model="newEducation.university" class="form-control" @input="e2 => newEducation.university = e2.target.value.toUpperCase()" />
                          <!-- <vue-select :options="universities" v-model="newEducation.university" placeholder="Select" /> -->
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-5">

                        <div class="input-block" v-if="newEducation.degree !== 'Secundaria'">
                          <label class="focus-label">Carrera</label>
                          <input type="text" v-model="newEducation.career" class="form-control"  @input="e2 => newEducation.career = e2.target.value.toUpperCase()"/>
                        </div>
                        
                        <div class="input-block" v-if="newEducation.degree == 'Secundaria'">
                          <label class="form-label">¿Tienes los estudios secundarios completos?</label>
                          <div class="check-radio">
                            <ul style="display:flex">
                                <li>
                                    <label class="custom_radio me-4">
                                        <input type="radio" name="budget" v-model="schoolCompleted" value="SI"/>
                                        <span class="checkmark border-agv"></span> SI
                                    </label>
                                </li>
                                <li style="margin-top: -20px;">
                                    <label class="custom_radio me-4">
                                        <input type="radio" name="budget" v-model="schoolCompleted" value="NO"/>
                                        <span class="checkmark border-agv"></span> NO
                                    </label>
                                </li>
                            </ul>
                          </div>
                        </div>

                      </div>
                      <!-- <div class="col-md-6 col-lg-3">
                        <div class="input-block">
                          <label class="focus-label">Descripcion</label>
                          <input type="text" v-model="newEducation.description" class="form-control" />
                        </div>
                      </div> -->
                      <div class="col-md-6 col-lg-3">
                        <div class="input-block">
                          <label class="focus-label">Fecha Inicio</label>
                          <div class="cal-icon">
                            <datepicker v-model="newEducation.startDate" placeholder="Elegir fecha" class="form-control datetimepicker" :editable="true" :clearable="false" />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-3">
                        <div class="input-block">
                          <label class="focus-label">Fecha Fin</label>
                          <div class="cal-icon">
                            <datepicker v-model="newEducation.endDate" placeholder="Elegir fecha" class="form-control datetimepicker" :editable="true" :clearable="false"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-3" style="margin-top:35px;">
                        <div class="input-block min-characters">
                          <label class="custom_check" style="padding-top:5px">
                            <input 
                            type="checkbox" 
                            name="select_time" 
                            value="SI" 
                            v-model="newEducation.actuallyStudying" 
                            />
                            <span
                              class="checkmark border-agv"
                            ></span>
                            Actualidad
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-3" style="margin-top:30px; text-align:center;">
                        <div class="input-block min-characters">
                          <div class="new-addd">
                            <a class="add-new text-success" @click="addEducation"><i class="feather-plus-circle me-1"></i> Agregar Nuevo</a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div id="education_add_row">
                      <div class="row" v-for="(education, index) in educations" :key="index">
                        <div class="col-md-12">
                          <h4>Educacion</h4>
                        </div>
                        <div class="col-md-6 col-lg-2">
                          <div class="input-block">
                            <label class="focus-label">Grado</label>
                            <vue-select :options="academicDegree" v-model="education.degree" placeholder="Select" />
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-5">
                          <div class="input-block">
                            <label class="focus-label">{{ education.degree == 'Secundaria' ? 'Institución Educativa' : 'Instituto/Universidad' }}</label>
                            <input type="text" v-model="education.university" class="form-control" @input="e2 => education.university = e2.target.value.toUpperCase()"/>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-5">

                          <div class="input-block" v-if="education.degree !== 'Secundaria'">
                            <label class="focus-label">Carrera</label>
                            <input type="text" v-model="education.career" class="form-control" @input="e2 => education.career = e2.target.value.toUpperCase()"/>
                          </div>

                          <div class="input-block" v-if="education.degree == 'Secundaria'">
                            <label class="form-label">¿Tienes los estudios secundarios completos?</label>
                            <div class="check-radio">
                              <ul style="display:flex">
                                  <li>
                                      <label class="custom_radio me-4">
                                          <input type="radio" name="budget" v-model="schoolCompleted" value="SI"/>
                                          <span class="checkmark border-agv"></span> SI
                                      </label>
                                  </li>
                                  <li style="margin-top: -20px;">
                                      <label class="custom_radio me-4">
                                          <input type="radio" name="budget" v-model="schoolCompleted" value="NO"/>
                                          <span class="checkmark border-agv"></span> NO
                                      </label>
                                  </li>
                              </ul>
                            </div>
                          </div>
                        
                        </div>
                        <!-- <div class="col-md-6 col-lg-3">
                          <div class="input-block">
                            <label class="focus-label">Descripcion(Opcional)</label>
                            <input type="text" v-model="newEducation.description" class="form-control" />
                          </div>
                        </div> -->
                        <div class="col-md-6 col-lg-3">
                          <div class="input-block">
                            <label class="focus-label">Fecha Inicio</label>
                            <div class="cal-icon">
                              <datepicker v-model="education.startDate" placeholder="Choose Date" class="form-control datetimepicker" :editable="true" :clearable="false" />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <div class="input-block">
                            <label class="focus-label">Fecha Fin</label>
                            <div class="cal-icon">
                              <datepicker v-model="education.endDate" placeholder="Choose Date" class="form-control datetimepicker" :editable="true" :clearable="false" />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-3" style="margin-top:35px;">
                          <div class="input-block min-characters">
                            <label class="custom_check" style="padding-top:5px">
                              <input 
                              type="checkbox" 
                              name="select_time" 
                              value="SI" 
                              v-model="education.actuallyStudying" 
                              />
                              <span
                                class="checkmark border-agv"
                              ></span>
                              Actualidad
                            </label>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-3" style="margin-top:30px; text-align:center;">
                          <div class="input-block min-characters">
                            <div class="new-addd">
                              <a @click="deleteEducation(index)" class="text-danger" style="cursor:pointer"><i class="feather-minus-circle me-1"></i>Eliminar</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Experiencia Laboral -->
                    <div class="row mt-3">
                      <div class="col-md-12">
                        <h4>Experiencia Laboral</h4>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="input-block">
                          <label class="focus-label">Nombre de Empresa</label>
                          <input type="text" v-model="newExperience.companyName" class="form-control" @input="e2 => newExperience.companyName = e2.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="input-block">
                          <label class="focus-label">Cargo</label>
                          <input type="text" v-model="newExperience.position" class="form-control" @input="e2 => newExperience.position = e2.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-2">
                        <div class="input-block">
                          <label class="focus-label">Sueldo</label>
                          <input type="number" v-model="newExperience.mount" class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4">
                        <div class="input-block">
                          <label class="focus-label">Descripcion</label>
                          <input type="text" v-model="newExperience.description" class="form-control" @input="e2 => newExperience.description = e2.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-2">
                        <div class="input-block">
                          <label class="focus-label">Fecha Inicio</label>
                          <div class="cal-icon">
                            <datepicker v-model="newExperience.startDate" placeholder="Elegir Fecha" class="form-control datetimepicker" :editable="true" :clearable="false" />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-2">
                        <div class="input-block">
                          <label class="focus-label">Fecha Fin</label>
                          <div class="cal-icon">
                            <datepicker v-model="newExperience.endDate" placeholder="Elegir Fecha" class="form-control datetimepicker" :editable="true" :clearable="false" />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-2" style="margin-top:35px;">
                        <div class="input-block min-characters">
                          <label class="custom_check" style="padding-top:5px">
                            <input 
                            type="checkbox" 
                            name="select_time" 
                            value="SI" 
                            v-model="newExperience.actuallyWorking" 
                            />
                            <span
                              class="checkmark border-agv"
                            ></span>
                            Actualidad
                          </label>
                        </div>
                      </div>
                    </div>

                    <div v-for="(experience, index) in experiences" :key="index" class="row">
                      <div class="col-md-6 col-lg-6">
                        <div class="input-block">
                          <label class="focus-label">Nombre de Empresa</label>
                          <input type="text" v-model="experience.companyName" class="form-control" @input="e2 => newExperience.companyName = e2.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="input-block">
                          <label class="focus-label">Cargo</label>
                          <input type="text" v-model="experience.position" class="form-control" @input="e2 => newExperience.position = e2.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-2">
                        <div class="input-block">
                          <label class="focus-label">Sueldo</label>
                          <input type="number" v-model="experience.mount" class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4">
                        <div class="input-block">
                          <label class="focus-label">Descripcion</label>
                          <input type="text" v-model="experience.description" class="form-control" @input="e2 => newExperience.description = e2.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-2">
                        <div class="input-block">
                          <label class="focus-label">Fecha Inicio</label>
                          <div class="cal-icon">
                            <datepicker v-model="experience.startDate" placeholder="Elegir Fecha" class="form-control datetimepicker" :editable="true" :clearable="false" />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-2">
                        <div class="input-block">
                          <label class="focus-label">Fecha Fin</label>
                          <div class="cal-icon">
                            <datepicker v-model="experience.endDate" placeholder="Elegir Fecha" class="form-control datetimepicker" :editable="true" :clearable="false" />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-2" style="margin-top:35px;">
                        <div class="input-block min-characters">
                          <label class="custom_check" style="padding-top:5px">
                            <input 
                            type="checkbox" 
                            name="select_time" 
                            value="SI" 
                            v-model="experience.actuallyWorking" 
                            />
                            <span
                              class="checkmark border-agv"
                            ></span>
                            Actualidad
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-3">
                        <div class="input-block">
                          <label class="focus-label">Nombre de Referente</label>
                          <input type="text" v-model="experience.nameContact" class="form-control" @input="e2 => experience.nameContact = e2.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-3">
                        <div class="input-block">
                          <label class="focus-label">Cargo del Referente</label>
                          <input type="text" v-model="experience.workPositionContact" class="form-control" @input="e2 => experience.workPositionContact = e2.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-3">
                        <div class="input-block">
                          <label class="focus-label">Celular del Referente</label>
                          <input type="text" v-model="experience.phoneContact" class="form-control" @input="e2 => experience.phoneContact = e2.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-3">
                        <div class="input-block">
                          <label class="focus-label">Correo del Referente</label>
                          <input type="text" v-model="experience.emailContact" class="form-control" />
                          <div class="new-addd">
                            <a class="remove_row" @click="deleteExperience(index)"><i class="feather-minus-circle me-1"></i>Eliminar</a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Idiomas -->
                    <div class="row">
                      <div class="col-md-12">
                        <h4>Idiomas</h4>
                      </div>
                      <div class="col-md-6 col-lg-4">
                        <div class="input-block">
                            <label class="focus-label">Lenguaje</label>
                            <vue-select :options="lenguageOptions" v-model="newLanguage.language" placeholder="Seleccionar" />
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4">
                        <div class="input-block">
                          <label class="focus-label">Nivel</label>
                          <vue-select :options="levelLenguage" v-model="newLanguage.level" placeholder="Seleccionar" />
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4" style="margin-top:30px;">
                        <div class="new-addd">
                          <a class="add-new text-success" @click="addLanguage"><i class="feather-plus-circle me-1"></i> Agregar Nuevo</a>
                        </div>
                      </div>
                    </div>
                    <div v-for="(language, index) in languages" :key="index" class="row">
                      <div class="col-md-6 col-lg-4">
                        <div class="input-block">
                          <label class="focus-label">Lenguaje</label>
                          <input type="text" v-model="language.language" class="form-control" @input="e2 => language.language = e2.target.value.toUpperCase()"/>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4">
                        <div class="input-block">
                          <label class="focus-label">Nivel</label>
                          <vue-select :options="levelLenguage" v-model="language.level" placeholder="Seleccionar" />
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4" style="margin-top:30px;">
                        <div class="new-addd">
                          <a class="remove_row" @click="deleteLanguage(index)"><i class="feather-minus-circle me-1"></i>Eliminar</a>
                        </div>
                      </div>
                    </div>


                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-block">
                                <label class="form-label">Cargar CV</label>
                                <div class="upload-sets">
                                    <label class="upload-filesview">
                                        Buscar archivo
                                        <input type="file" @change="handleFileUpload" accept=".pdf,.docx" style="cursor:pointer;"/>
                                    </label>
                                </div>
                                <span v-if="fileCvApplicantName" class="file-name text-success text-center" style="width:100%">{{ fileCvApplicantName }}</span>
                            </div>
                            <span>
                                (Los formatos permitidos son .pdf, .docx)
                            </span>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div>
                                <label class="custom_check">
                                <input type="checkbox" name="select_time" style="margin-top:-15px"/>
                                <span class="checkmark"></span>He leído y acepto los <span class="text-success" data-bs-toggle="modal" data-bs-target="#terms_conds">Términos y Condiciones</span> y las <span class="text-success" data-bs-toggle="modal" data-bs-target="#polit_privacy">Políticas de Privacidad</span>
                                </label>
                            </div>
                        </div>
                    </div>
                  </form>
                </div>

                <div class="text-center">
                  <input class="btn btn-prev prev_btn btn-back" @click="previousStep" :disabled="currentStep === 2"
                    name="next" type="button" value="Atrás">
                  <input class="btn btn-primary btn-get btn-next" @click="nextStep('edu_exp_lab')"
                    :disabled="currentStep === totalSteps" name="next" value="Registrar &nbsp;&nbsp;" style="font-weight: bold;">
                  <!-- <input class="btn next_btn btn-primary btn-get btn-next" @click="nextStep"
                    :disabled="currentStep === totalSteps" name="next" type="submit" value="Next"> -->
                </div>
              </div>
              <!-- /Skills & Experience -->

              <div class="on-board field-card select-account select-btn" v-if="currentStep === 4">
                <div class="text-center onboard-head">
                  <h2>¡Cuenta creada con éxito!</h2>
                  <p class="mt-5">Tu cuenta ha sido creada satisfactoriamente. Ahora puedes acceder a nuestra plataforma.</p>
                  <p>¡Gracias por unirte a nosotros!</p>
                  <p>El equipo de AGROVISION</p>
                  <router-link 
                  to="/login" 
                  class="btn btn-primary pt-2" 
                  tabindex="-1" 
                  style="color:white; padding: 10px 15px; box-shadow: 0 0 5px #fff; height: 40px;"
                  >
                      Iniciar Sesión
                  </router-link>
                  <!-- <input class="btn btn-prev prev_btn btn-back" @click="previousStep" :disabled="currentStep === 2"
                  name="next" type="button" value="Back"> -->
                </div>
              </div>

              <div class="row justify-content-center mb-5">
                <div v-if="showErrorMessage" class="alert alert-danger alert-dismissible fade show col-md-6" role="alert" style="position:absolute; z-index: 2; justify-content:center">
                  <strong>Error:</strong> {{ errorMessage }}
                  <button type="button" class="btn-close" @click="showErrorMessage = false" aria-label="Close"></button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Pie de Página -->
  <footeragv></footeragv>

  <VDialog v-model="dialogLoading" :max-width="700">
    <VCard class="pa-sm-10 pa-5">
      <VCardTitle class="text-center">Cargando información</VCardTitle>
      <VProgressLinear indeterminate color="primary"></VProgressLinear>
    </VCard>
  </VDialog>
</template>
<script>
import axiosIns from '@/plugins/axios.js';
import { ref } from "vue";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";

// const currentDate = ref(new Date());
// const currentDateOne = ref(new Date());
// const currentDateTwo = ref(new Date());
// const currentDateThree = ref(new Date());
// const currentDateFour = ref(new Date());
export default {
  components: {
    Form,
    Field,
  },
  data() {
    return {
      dialogLoading: false,
      showPassword: false,
      // password: null,
      emailError: "",
      passwordError: "",
      currentStep: 1,
      totalSteps: 4,
      
      username: null,
      email: null,
      password: null,

      name: null,
      firstSurname: null,
      secondSurname: null,
      selectedTypeDoc: null,
      typeDocs: ["C.E.","DNI","PASAPORTE"],
      n_doc: null,
      phone: null,
      birthdate: null,
      selectedGender: null,
      genders: ["Masculino","Femenino"],
      selectedMaritalStatus : null,
      maritalStatus : ["Soltero","Casado","Divorciado","Conviviente"],
      nationality: null,
      country: null,
      departament: null,
      province: null,
      district: null,
      salary_expect: null,
      personalDescription: null,
      availabTravel: 'NO',
      availabChangeResid: 'NO',
      driversLicense: 'NO',
      typesDriversLicense : ['NINGUNO',"A-I","A-IIa","A-IIIa","A-IIb","A-IIb","A-IIIb","B-I","B-IIa","B-IIb","B-IIc"],
      selectedDriversLicense: null,
      disability: 'NO',

      schoolCompleted: null,

      // levelLenguage: ["Basico", "Intermedio", "Avanzado"],
      // academicDegree: ["Select", "Bachelor's degree", "Master's Degree"],
      // certification: ["Select", "Certification", "Award"],
      // socialNetworks:["Linkedin","Facebook","Instagram","Tik Tok"],
      // startdate: currentDate,
      // startdateOne: currentDateOne,
      // startdateTwo: currentDateTwo,
      // startdateThree: currentDateThree,
      // startdateFour: currentDateFour,
      // skills: [],
      // educations: [],
      // certify: [],
      // experiences: [],
      // languages: [],

      // universities: [
      //   "Universidad Nacional de Piura",
      //   "Universidad Nacional de Cajamarca",
      //   "Universidad Nacional Mayor de San Marcos",
      //   "Universidad Nacional Pedro Ruiz Gallo",
      //   "Universidad Nacional de Ingeniería",
      //   "Universidad Tecnologica del Perú",
      //   "Universidad Señor de Sipan",
      //   "Universidad Católica Santo Toribio de Mogrovejo",
      //   "Universidad Cesar Vallejo",
      //   "Universidad Nacional de Trujillo",
      // ],

      levelLenguage: ["Basico", "Intermedio", "Avanzado"],
      lenguageOptions: ["Español", "Inglés", "Francés", "Portugués", "Chino", "Ruso", "Árabe", "Alemán", "Japonés", "Italiano"],
      academicDegree: ["Primaria","Secundaria","Egresado técnico", "Titulado Técnico", "Egresado universitario","Bachiller","Titulado universitario"],
      socialNetworks: ["Linkedin", "Facebook", "Instagram", "Tik Tok"],
      // schoolCompleted: "",
      newEducation: {
        degree: "",
        university: "",
        career: "",
        startDate: "",
        endDate: "",
        actuallyStudying: 'NO',
      },
      educations: [],
      newExperience: {
        companyName: "",
        position: "",
        mount: "",
        description: "",
        startDate: "",
        endDate: "",
        actuallyWorking: 'NO',
        nameContact:"",
        workPositionContact:"",
        phoneContact:"",
        emailContact:"",
      },
      experiences: [],
      newLanguage: {
        language: "",
        level: ""
      },
      languages: [],
      
      fileCvApplicant:null,
      fileCvApplicantName:null,
      imgApplicant:null,
      imgPreviewApplicant:null,
      bumeranInvitation: false,
      termsAccepted: 'NO',

      showErrorMessage:false,
      errorMessage:null,
      // startdate: currentDate,
    };
  },
  mounted(){

  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    validateEmail(email){
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
    nextStep(value) {
      const yo = this
      yo.dialogLoading = true
      if (this.currentStep < this.totalSteps) {
        if(value == 'acceso_sistema'){
          console.log("validacion de email", yo.email, yo.validateEmail(yo.email))
          if(yo.email != null && yo.validateEmail(yo.email) && yo.email != null && yo.password != null){
            // this.currentStep++;
            this.checkEmailDni(yo.email, 'email')
          }else{
            yo.showErrorMessage = true
            yo.errorMessage = "Debes completar todos los campos antes de continuar"
            yo.dialogLoading = false
          }
        }else if(value == 'datos_pers'){
          if(yo.name != null || yo.firstSurname != null || yo.secondSurname != null ||yo.selectedTypeDoc != null || yo.n_doc != null || yo.phone != null || yo.selectedGender != null
            || yo.personalDescription != null
          ){
            // this.currentStep++;
            this.checkEmailDni(yo.n_doc, 'n_doc')
          }else{
            yo.showErrorMessage = true
            yo.errorMessage = "Debes completar todos los campos antes de continuar"
            yo.dialogLoading = false
          }
        }else if(value == 'edu_exp_lab'){
          // yo.currentStep++;
          this.addApplicant()
        }

      }
    },
    previousStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    showProgress(step) {
      return this.currentStep === step;
    },

    addApplicant(){
      const yo = this
      // Añadir la nueva educación si no está vacía
      if (this.newEducation.degree || this.newEducation.university || this.newEducation.startDate || this.newEducation.endDate) {
        this.educations.push({ ...this.newEducation });
      }
      if(this.educations.length == 0){
        yo.showErrorMessage = true
        yo.errorMessage = "Debes completar al menos un nivel de educación."
        yo.dialogLoading = false
        yo.currentStep--;
        return false
      }else{
        if(this.educations[0].degree == "" || this.educations[0].university == "" || this.educations[0].startDate == "" || this.educations[0].endDate == ""){
          yo.showErrorMessage = true
          yo.errorMessage = "Complete los datos de educación."
          yo.dialogLoading = false
          yo.currentStep--;
          return false
        }
      }
      // console.log('lista de estudios',this.educations)

      // Añadir la nueva experiencia si no está vacía
      if (this.newExperience.companyName || this.newExperience.position || this.newExperience.startDate || this.newExperience.endDate) {
        this.experiences.push({ ...this.newExperience });
      }
      // console.log('lista de experiencias', this.experiences)
      if(this.experiences.length == 0){
        yo.showErrorMessage = true
        yo.errorMessage = "Debes completar al menos una experiencia laboral."
        yo.dialogLoading = false
        yo.currentStep--;
        return false
      }else{
        if(this.experiences[0].companyName == "" || this.experiences[0].position == "" || this.experiences[0].startDate == "" || this.experiences[0].endDate == ""){
          yo.showErrorMessage = true
          yo.errorMessage = "Complete los datos de experiencia laboral."
          yo.dialogLoading = false
          yo.currentStep--;
          return false
        }
      }

      // Añadir el nuevo idioma si no está vacío
      if (this.newLanguage.language || this.newLanguage.level) {
        this.languages.push({ ...this.newLanguage });
      }

      const formData = new FormData();

      yo.username = yo.email.split("@")[0];

      formData.append('username', yo.username);
      formData.append('email', yo.email);
      formData.append('password', yo.password);

      formData.append('name', yo.name);
      formData.append('first_surname', yo.firstSurname);
      formData.append('second_surname', yo.secondSurname);
      formData.append('type_doc', yo.selectedTypeDoc);
      formData.append('n_doc', yo.n_doc);
      formData.append('phone', yo.phone);
      formData.append('birthdate', yo.birthdate);
      formData.append('gender', yo.selectedGender);
      formData.append('marital_status', yo.selectedMaritalStatus);
      formData.append('nationality', yo.nationality);
      formData.append('country', yo.country);
      formData.append('departament', yo.departament);
      formData.append('province', yo.province);
      formData.append('district', yo.district);
      formData.append('salary_expect', yo.salary_expect);
      formData.append('personal_desc', yo.personalDescription);
      formData.append('availab_travel', yo.availabTravel);
      formData.append('availab_change_resid', yo.availabChangeResid);
      // formData.append('drivers_license', yo.driversLicense);
      formData.append('drivers_license', yo.selectedDriversLicense);
      formData.append('disability', yo.disability);

      formData.append('school_completed', yo.schoolCompleted);
      formData.append('educations', JSON.stringify(yo.educations));
      formData.append('experiences', JSON.stringify(yo.experiences));
      formData.append('languages', JSON.stringify(yo.languages));

      formData.append('img_applicant', yo.imgApplicant);
      formData.append('file_cv_applicant', yo.fileCvApplicant);
      formData.append('terms_accepted', yo.termsAccepted);

      // formData.append('language', yo.language);

      const config = {
        method: 'post',
        url: '/talentoagv/createApplicant/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'][0] === false){
            // yo.errorMessage = ""
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.currentStep++;
          }else{
            yo.errorMessage = "Ocurrió un problema con la creación de la cuenta, por favor intentelo mas tarde."
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          yo.dialogLoading = false
        })
    },

    handlePhotoChangeApplicant(event) {
      const file = event.target.files[0];
      if (file) {
          this.imgApplicant = file;
          this.imgPreviewApplicant= URL.createObjectURL(file);
      }
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.fileCvApplicant = file;
        this.fileCvApplicantName = file.name;
      } else {
          this.fileCvApplicant = '';
      }
    },

    addEducation() {
      this.educations.push({ ...this.newEducation });
      this.newEducation = { 
        degree: "", 
        university: "", 
        career: "", 
        startDate: "", 
        endDate: "", 
        actuallyStudying:"NO"
      };
    },
    deleteEducation(index) {
      this.educations.splice(index, 1);
    },
    addExperience() {
      this.experiences.push({ ...this.newExperience });
      this.newExperience = { 
        companyName: "", 
        position: "", 
        mount: "", 
        description: "", 
        startDate: "", 
        endDate: "", 
        actuallyWorking:"NO",
        nameContact:"",
        workPositionContact:"",
        phoneContact:"",
        emailContact:"",
      };
    },
    deleteExperience(index) {
      this.experiences.splice(index, 1);
    },
    addLanguage() {
      this.languages.push({ ...this.newLanguage });
      this.newLanguage = { language: "", level: "" };
    },
    deleteLanguage(index) {
      this.languages.splice(index, 1);
    },

    checkEmailDni(value, type){
      const yo = this
      const data = JSON.stringify({
        type : type,
        value : value
      })

      const config = {
        method: 'post',
        url: '/talentoagv/checkEmailDni/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      }

      axiosIns(config)
        .then(function (response) {
          console.log(response.data['is_error'])
          console.log(yo.currentStep)
          if (response.data['is_error'] === false){
            yo.showErrorMessage = false
            yo.errorMessage = ""
            yo.currentStep++;
          }else{
            yo.showErrorMessage = true
            yo.errorMessage = response.data['message']
          }
        })
        .catch(function (error) {
          console.log(error);
          // yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          yo.dialogLoading = false
        })

    }

    // addSkill() {
    //   this.skills.push({
    //       skill: "",
    //       Level: "Choose Level",
    //   });
    // },
    // deleteSkill(index) {
    //   this.skills.splice(index, 1);
    // },
    // addeducation() {
    //   this.educations.push({});
    // },
    // deleteeducation(index) {
    //   this.educations.splice(index, 1);
    // },
    // addcertify() {
    //   this.certify.push({});
    // },
    // deletecertify(index) {
    //   this.certify.splice(index, 1);
    // },
    // addexperience() {
    //   this.experiences.push({});
    // },
    // deleteexperience(index) {
    //   this.experiences.splice(index, 1);
    // },
    // addlanguage() {
    //   this.languages.push({});
    // },
    // deletelanguage(index) {
    //   this.languages.splice(index, 1);
    // },
  },
  setup(){
    const schema = Yup.object().shape({
      email: Yup.string().required("Email es obligatorio").email("Email is invalid"),
      // password: Yup.string()
      //   // .min(6, "Contras")
      //   .required("Contraseña es obligatoria"),
    });
    return {
      schema,
    };
  },
  name: "onboard-screen",
};
</script>
<style>
.multistep-form .on-board {
  display: block !important;
}

.border-agv{
  border: 2px solid #6BB545 !important;
}

/* input[type="text"] {
    text-transform: uppercase;
} */

/* Evita que los placeholders se muestren en mayúsculas */
input::placeholder {
    text-transform: none;
}
</style>